const INCUBATE_DEFAULTS = { slot: 1 };

export default function addDefaultArgumentValues<
  A extends Record<string, unknown> | null,
  B extends Record<string, unknown> = Partial<A>
>(action: string, actionArguments: A, taskAppliedParameters?: B | null): A {
  const defaults = action === 'incubate' ? INCUBATE_DEFAULTS : {};

  return {
    ...defaults,
    ...actionArguments,
    ...(taskAppliedParameters || {}),
  };
}
